export default "__VITE_ASSET__CF6gHWgH__"